import { FC } from "react";
import { IStudent } from "../../../models/students.model";
import StudentName from "./Name";
import Score from "./Score";

interface IProps {
  student: IStudent|undefined;
}

const ScoreContainer: FC<IProps> = ({
  student,
}) => {
  return (
    <>
      <StudentName student={student} />
      <div className="mt-3" />
      <Score memberCode={student?.studentCode} />
    </>
  );
}

export default ScoreContainer;
